<template>
  <div class="classVideo primary fRow aCenter jCenter">
    <a :href="item.url" class="growFull fRow jStart aCenter" target="_blank">
      <i class="material-icons-round">play_arrow</i>
      <label class="growFull">ویدئوی شماره {{index + 1}}</label>
    </a>
    <i class="material-icons-round remove"
      @click="toggleDeleteDialog" v-if="canDelete">close</i>
    <div class="dialog fCol jCenter aCenter" v-if="deleteDialog">
      <div class="bo fRow jStart aStart wrap" v-if="!l">
        <div class="t fullWidth"
          >آیا از حذف «ویدئوی شماره {{index + 1}}» مطمئن هستید؟</div>
        <div class="b" @click="deleteVideo(item.recordId)">بله، حذف کن</div>
        <div class="b yes" @click="toggleDeleteDialog">انصراف</div>
      </div>
      <lottie-animation
        v-if="l"
        path="./animations/progress.json"
        :loop="true"
        :autoPlay="true"
        :width="96"
        :height="96"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';
import errorHandler from '@/mixins/mixin';

export default {
  mixins: [errorHandler],
  props: ['item', 'index', 'canDelete', 'roomId', 'url', 'v'],
  data() {
    return {
      deleteDialog: false,
      l: false,
      m: '',
    };
  },
  components: {
    LottieAnimation,
  },
  methods: {
    toggleDeleteDialog() {
      this.deleteDialog = !this.deleteDialog;
    },
    deleteVideo(recordId) {
      this.l = true;
      // console.log(recordId);
      if (true) {
        axios({
          method: 'delete',
          url: `${this.url}/api/v${this.v}/Rooms/remove/${this.roomId}?RecordId=${recordId}`,
          headers: {
            Authorization: `bearer ${localStorage.getItem('user').replace(/"/g, '')}`,
          },
          data: {},
        }).then(
          (response) => {
            this.deleteDialog = false;
            if (response.data.isSuccess) {
              // console.log(response.data);
              this.l = false;
              this.m = response.data.message;
              this.$emit('deleted', true);
              // this.openRecord();
            } else {
              this.l = false;
              this.m = response.data.message;
              this.makeToast('warning', response.data.message, 3000);
              this.$emit('resp', this.m);
            }
          },
          (error) => {
            // error
            this.deleteDialog = false;
            this.l = false;
            this.m = this.errorHandler(error);
            this.makeToast('warning', this.errorHandler(error), 3000);
            this.$emit('resp', this.m);
          },
        ).catch(() => {
          // eslint-disable-next-line
          this.deleteDialog = false;
          this.l = false;
          this.m = 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید';
          this.$emit('resp', this.m);
          this.makeToast('catch', 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید', 4000);
        });
      }
    },
  },
  mounted() {
    // console.log(this.item);
  },
};
</script>

<style>

</style>
